import React, { Fragment, useState,useEffect } from "react";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Link,useParams,useNavigate } from "react-router-dom";
import Snackbars from "../../../utils/Snackbars";
import * as Yup from "yup";
import { useFormik } from "formik";
import useRequests from "../../../utils/useRequests";

const CMSPagesEdit = () => {
    const { getRequest , putRequest} = useRequests();
    const { page_slug } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    
    const [cmsdata, setCmsData] = useState({
        page_title : "",
        page_content:""
    })
    const [AlertData, setAlertData] = React.useState({
                    variant: '',
                    message: '',
                  });
                
                  const resetAlertData = () => {
                    setTimeout(() => {
                      setAlertData((AlertData) => ({
                        ...AlertData,
                        variant: '',
                        message: '',
                      }));
                    }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
                  };
    
                  const fetchCMSPage = async () => {
                    const response = await getRequest(`cms-page/${page_slug}`);
                    if (response && response.code === 200) {
                        console.log(response.data,'resultData');
                        const data = response.data[0];
                
                        // Format datetime for input fields
                       
                
                        setCmsData({
                            page_title:data.page_title,
                            page_content:data.page_content,
                        });
                        console.log(cmsdata,'cms')
                    } else {
                        setAlertData((AlertData) => ({
                            ...AlertData,
                            variant: 'error',
                            message: 'Failed to fetch CMS page',
                          }));
                       
                    }
                    resetAlertData();
                    setLoading(false);
                };
                useEffect(() => {
                            fetchCMSPage()
                            setLoading(false);
                            }, []);
        const validation1 = useFormik({
                enableReinitialize: true,
            initialValues: cmsdata,
            
                validationSchema: Yup.object({
        
                  page_title: Yup.string().required('Page title is required'),
                  page_content: Yup.string().required('Page content is required'),
                  
                }),
               onSubmit: async ( values) => {
                // e.preventDefault();
        
                try {
                    let submit1 = document.getElementById('submit1');
                    submit1.disabled = true;
                    submit1.textContent = ('Processing...');
                    // Convert form data to JSON
                    const jsonpar = JSON.stringify({
                        page_title:values.page_title,
                        page_content:values.page_content,
                        
                    });
        
                    // Make the PUT request to update the user
                    const res = await putRequest(`cms-edit/${page_slug}`, jsonpar);
                    console.log('res',res)
                    // Handle the response
                    if (res && res.code === 200) {
                      
                        setCmsData({
                            page_title:"",
                            page_content:""
                        });
                        navigate("/cms-page-list",{
                            state:{
                                variant: "success",
                                message:  `${values.page_title} page updated successfully!`,
                            }
                        }); // Redirect on success
                    } else {
                        setAlertData((AlertData) => ({
                            ...AlertData,
                            variant: 'error',
                            message: res.message || `Failed to update ${values.page_title}.`,
                          }));
                          resetAlertData();
                    }
                    submit1.disabled = false;
                    submit1.textContent = ('Update');
                } catch (error) {
                    console.error("Error: ", error);
                  
                    setAlertData((AlertData) => ({
                        ...AlertData,
                        variant: 'error',
                        message: "An error occurred while updating the CMS page.",
                      }));
                      resetAlertData();
                }
            }
             });
    return (
        <Fragment>
            <div className="d-sm-flex d-block justify-content-between align-items-center mb-4">
                <h2 className="text-black font-w700 mb-0">Edit CMS Page</h2>
            </div>

            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <div className="basic-form">
                            {AlertData.message !== "" ? (
                                <Snackbars variant={AlertData.variant} message={AlertData.message} />
                            ) : (
                                ""
                            )}
                            <form >
                                <div className="row mb-3">
                                    <div className="form-group mb-3 col-md-12">
                                        <label>Page Title :</label>
                                        <input 
                                            type="text"
                                            placeholder="Please Enter Page Title" 
                                            className={`form-control ${validation1.touched.page_title && validation1.errors.page_title ? 'is-invalid' : ''}`}
                                            name="page_title"
                                            value={validation1.values.page_title || ''}
                                            onChange={validation1.handleChange}
                                            onBlur={validation1.handleBlur}
                                            invalid={
                                            validation1.touched.page_title && validation1.errors.page_title ? true : false
                                            }
                                            
                                        />
                                        {validation1.touched.page_title && validation1.errors.page_title ? (
                                            <div className="invalid-feedback" >{validation1.errors.page_title}</div>
                                        ) : null}
                                    </div>
                                    <div className="form-group mb-3 col-md-12">
                                        <label>Page Description :</label>
                                        <CKEditor
                                            editor={ClassicEditor}
                                            data={validation1.values.page_content || ''} 
                                            onReady={editor => {
                                                console.log('Editor is ready to use!', editor);
                                            }}
                                            onChange={(event, editor) => {
                                                const cmsdata = editor.getData();
                                                validation1.setFieldValue('page_content', cmsdata);
                                            }}
                                            onBlur={() => {
                                                validation1.setFieldTouched('page_content', true);
                                            }}
                                            onFocus={(event, editor) => {
                                                console.log('Focus.', editor);
                                            }}
                                        />
                                        {validation1.touched.page_content && validation1.errors.page_content ? (
                                            <div className="invalid-feedback" >{validation1.errors.page_content}</div>
                                        ) : null}
                                    </div>
                                </div>
                                <Link to="/cms-page-list" type="submit" className="btn btn-primary me-2"
                                
                                id="submit1"onClick={(e) => {
                                    e.preventDefault();
                                    validation1.handleSubmit();
                                    return false;
                                  }}>
                                  {('Update')}
                                </Link>
                                <Link to="/cms-page-list" className="btn btn-light">Cancel</Link>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default CMSPagesEdit;
